import { render, staticRenderFns } from "./BudgetCategoryModal.vue?vue&type=template&id=0edcbcdf&scoped=true&"
import script from "./BudgetCategoryModal.vue?vue&type=script&lang=js&"
export * from "./BudgetCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./BudgetCategoryModal.vue?vue&type=style&index=0&id=0edcbcdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edcbcdf",
  null
  
)

export default component.exports